import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';
import c from '@/assets/json/countries_and_sub_divisions.json';
import allCurrencies from '@/assets/json/currencies.json';
import nationalities from '@/assets/json/nationalities.json'; 
import moment from 'moment-timezone';

export const state = {
  loading: false,
  apps: [],
  appModules: [],
  activeCompany: {},
  branch: {},
  branches: [],
  countries: [],
  provinces: [],
  nationalities: [],
  currencies: [],
  roles: [],
  timezones: [],
  profileUpdatedDialog: false
};

export const mutations = make.mutations(state);

export const getters = {
  ...make.getters(state),
  activeBranches: (state) =>
    (state.branches || []).filter((el) => el.is_active),
  getTimezonesAndOffsets(state) {
    let offsetTmz = [];

    for (let i in state.timezones) {
      offsetTmz.push({
        zone: state.timezones[i],
        format:
          ' (GMT' +
          moment.tz(state.timezones[i]).format('Z') +
          ') ' +
          state.timezones[i]
      });
    }
    return offsetTmz;
  }
};

export const actions = {
  init: ({ commit, dispatch, rootState }) => {
    dispatch('getTimezones');
    const user = rootState.authModule.user;
    if (user && user.role) {
      commit('authModule/SET_USER', user, { root: true });
    }
    return new Promise((resolve, reject) => {
      const modules = [
        'companyModule/fetchCompany',
        'roleModule/fetchRoles',
        'branchModule/fetchBranches',
        'coreModule/fetchCountries',
        'coreModule/fetchNationalities',
        'appModulesModule/getAppModules',
        'coreModule/fetchCurrencies'
      ];
      const dispatchChain = [];
      for (const module of modules) {
        dispatchChain.push(dispatch(module, null, { root: true }));
      }

      const promiseQueue = Promise.all(dispatchChain);
      promiseQueue
        .then(async ([company, roles, branches, countries, nationalities, apps, currencies]) => {
          commit('SET_ACTIVE_COMPANY', company);
          commit('SET_ROLES', roles);
          commit('SET_BRANCHES', branches);
          commit('SET_COUNTRIES', countries);
          commit('SET_NATIONALITIES', nationalities);
          commit('SET_APP_MODULES', apps.selectedModules);
          commit('SET_CURRENCIES', currencies);
          resolve(true);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  fetchCountries: async ({ commit }) => {
    try {
      let countries = [];
      const data = c;
      for (const countryKey in data) {
        const province = [];
        for (const key in data[countryKey].divisions)
          province.push(data[countryKey].divisions[key]);

        countries.push({ name: data[countryKey].name, provinces: province });
      }
      commit('SET_COUNTRIES', countries);
      return countries;
    } catch (error) {
      Logger.error('fetching countries', error);
    }
  },

  fetchNationalities: async ({ commit }) => {
    try {
      commit ('SET_NATIONALITIES', nationalities);
      return nationalities;
    } catch (error) {
      Logger.error('fetching nationalities',error);
    }
  },

  getCountryProvinces({ state, commit }, key) {
    if (!key) return;

    const country = state.countries.find((el) => el.name.indexOf(key) > -1);
    commit('SET_PROVINCES', country.provinces || []);
  },

  getTimezones({ commit }) {
    let timeZones = moment.tz.names();
    commit('SET_TIMEZONES', timeZones);
  },

  fetchCurrencies: async ({ commit }) => {
    try {
      let currencies = [];
      const data = allCurrencies;
      for (const currencyKey in data) {
        if (data.hasOwnProperty(currencyKey)) {
          currencies.push({
            code: data[currencyKey].code,
            name: data[currencyKey].name,
            symbol: data[currencyKey].symbol,
            symbol_native: data[currencyKey].symbol_native,
            decimal_digits: data[currencyKey].decimal_digits,
            rounding: data[currencyKey].rounding,
            name_plural: data[currencyKey].name_plural
          });
        }
      }
      commit('SET_CURRENCIES', currencies);
      return currencies;
    } catch (error) {
      Logger.error('fetching currencies', error);
    }
  }

};
